import React from 'react';
import { Card, CardBody, } from 'reactstrap';
type PricingCardProps = {
    title: string;
    currency?: string;
    price: number | string;
    period?: string;
    periodNote?: React.ReactNode;
    features: (string | React.ReactNode)[];
    included?: string;
    ctaText?: string;
    onCtaClick?: () => void;
    className?: string;
    highlight?: boolean;
    disabled?: boolean;
};

const PricingCard: React.FC<PricingCardProps> = ({
    title,
    currency = '£',
    price,
    included = 'Included',
    period = '/month',
    periodNote,
    features,
    ctaText = 'Select',
    onCtaClick,
    className = '',
    highlight = false,
    disabled = false,
}) => {
    return (

        <Card className={
            `pricing-box ribbon-box right  card border rounded-2 shadow-md mb-1 ${className} ` +
            (highlight ? 'pricing-card--highlight ' : '')
        } >
            <CardBody className="px-0 pt-0 pb-2">
                <div className="d-flex flex-column text-center">
                    <div className="flex-grow-1 py-2 bg-primary-subtle">
                        <h5 className="mb-0 fw-semibold fs-14 rounded-2 ">{title}</h5>
                    </div>

                    <div className="mt-2 mb-2">
                        <h4 className="month text-primary fs-16 mb-0"> <span className="fs-5 text-teal">{currency}</span>{price} </h4>
                        <small style={{ position: 'relative', top: '-6px' }}>{period}</small>
                        {periodNote && <div className="fs-12 lh-sm">{periodNote}</div>}
                    </div>
                    {/* <div className="flex-grow-1  text-primary fw-bold">
                        <span>{included}</span>
                    </div> */}
                </div>
                {/*<ul className="list-unstyled mb-0 d-flex flex-column align-items-center">
                    {features.map((f, i) => (
                        <li key={i} className="d-flex align-items-center mb-1" style={i === features.length - 1 ? { position: 'relative', top: '-6px' } : {}}>

                            <div
                                className="text-success d-flex align-items-center justify-content-center"
                                style={{ width: '20px' }}
                            >
                                <i className="fa fa-solid fa-circle-check fs-15"></i>
                            </div>


                            <div style={{ minWidth: '60px' }}>
                                <span className="fs-11">{f}</span>
                            </div>
                        </li>
                    ))}
                </ul>*/}

                <div className='text-center'>
                    <button
                        type="button"
                        onClick={onCtaClick}
                        disabled={disabled}
                        className={`btn text-center py-1 ${highlight ? 'btn-success' : 'btn-outline-success'
                            }`}
                    >
                        {ctaText}
                    </button>
                </div>

            </CardBody>
        </Card>
    );
};

export default PricingCard;
